
import util from "../util";
import Cookies from "js-cookie";
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

export default {
name: "Main",
components: {
Tabbar,
TabbarItem
},
data() {
return {
isWXClient: util.isWXClient() && Cookies.get("code"),
cachedViews: ["Home"],
active_home: this.$route.name == "Home" ? true : false
};
},
watch: {
$route(to) {
this.active_home = to.name == "Home" ? true : false;
}
},
mounted() {



},
methods: {
initWx() {
this.$http("post", "/user/qrCode", {
url: location.href
}).then(response => {
let res = response.data;

wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.appId, // 必填，公众号的唯一标识
timestamp: res.timestamp, // 必填，生成签名的时间戳
nonceStr: res.nonceStr, // 必填，生成签名的随机串
signature: res.signature, // 必填，签名
jsApiList: [
"checkJsApi",
"scanQRCode",
"hideMenuItems",
"addCard",
"chooseCard",
"hideMenuItems",
"openCard"
] // 必填，需要使用的JS接口列表
});

wx.ready(() => {

wx.hideMenuItems({
menuList: [
"menuItem:share:timeline",
"menuItem:share:appMessage",
"menuItem:copyUrl",
"menuItem:openWithSafari",
"menuItem:openWithQQBrowser",
"menuItem:originPage"
] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
});
});
});
}
}
};
